import Vue from 'vue'
import Vlf from 'vlf'

Vue.use(Vlf)